module.exports = __webpack_public_path__ + "static/yellowTruck-a4c41ea4f86da2848297d0aabf0f0ce3.png";